var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 817,
    height: 282,
    viewBox: "0 0 817 282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "focm6qd1ra",
    x1: "49.307%",
    x2: "49.307%",
    y1: "100%",
    y2: ".135%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.963%",
    stopColor: "#9AD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#99D4FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A90E2",
    strokeWidth: 0.85
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84 24L136.828 54.5 136.828 115.5 84 146 31.172 115.5 31.172 54.5z",
    opacity: 0.403,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -228.492)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M579 81L631.828 111.5 631.828 172.5 579 203 526.172 172.5 526.172 111.5z",
    opacity: 0.203,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -2018.857)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M183 81L235.828 111.5 235.828 172.5 183 203 130.172 172.5 130.172 111.5z",
    opacity: 0.6,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -540.965)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M381 81L433.828 111.5 433.828 172.5 381 203 328.172 172.5 328.172 111.5z",
    opacity: 0.203,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -1279.911)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M84 138L136.828 168.5 136.828 229.5 84 260 31.172 229.5 31.172 168.5z",
    opacity: 0.603,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -114.492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 23L334.828 53.5 334.828 114.5 282 145 229.172 114.5 229.172 53.5z",
    opacity: 0.203,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -968.438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 23L532.828 53.5 532.828 114.5 480 145 427.172 114.5 427.172 53.5z",
    opacity: 0.6,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -1707.384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 23L730.828 53.5 730.828 114.5 678 145 625.172 114.5 625.172 53.5z",
    opacity: 0.203,
    transform: "translate(-22 -30) matrix(-1 0 0 1 762 59) scale(-1 1) rotate(30 0 -2446.33)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#focm6qd1ra)",
    d: "M678 23L730.828 53.5 730.828 114.5 678 145 625.172 114.5 625.172 53.5z",
    opacity: 0.503,
    transform: "translate(-22 -30) matrix(1 0 0 -1 99 285) scale(-1 1) rotate(30 0 -2446.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 140L136.828 170.5 136.828 231.5 84 262 31.172 231.5 31.172 170.5z",
    opacity: 0.603,
    transform: "translate(-22 -30) matrix(1 0 0 -1 99 285) scale(-1 1) rotate(30 0 -112.492)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHex);
export default __webpack_public_path__ + "static/media/home-hex.ee593e64bad68cf0e1fb9e0d75528467.svg";
export { ForwardRef as ReactComponent };